import axios from 'axios';

// Create an axios instance with base URL from environment variables
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for handling requests
apiClient.interceptors.request.use(
  (config) => {
    // You can add authentication tokens or other request modifications here
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for handling responses
apiClient.interceptors.response.use(
  (response) => {
    // You can process successful responses here
    return response;
  },
  (error) => {
    // You can handle errors globally here
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiClient;